import React, { Component } from "react";
import { Selector, Nav, Header } from "../NewManageUsers/ManagePane";
import { SelectLicense } from "./";
import { Row, Col } from "reactstrap";
import getSchoolAndDistrictAccountLicenses from "../../../helpers/users/licenses/getSchoolAndDistrictAccountLicenses";
import { BeatLoader } from "react-spinners";
import getAllStudents from "../../../helpers/users/licenses/getAllStudents";
import getAllEducators from "../../../helpers/users/licenses/getAllEducators";

import toggleStudentLicense from "../../../helpers/users/licenses/toggleStudentLicense";
import addOrRemoveStudentLicense from "../../../helpers/users/licenses/addOrRemoveStudentLicense";
import { tallyLicenseInUserLicenses } from "../../../helpers/users/licenses/tallyLicenses";
import forOwn from "mout/object/forOwn";
import checkLicenseLimit, {
  checkLicenseLimitForSingleItem
} from "../../../helpers/users/licenses/checkLicenseLimit";

class StudentLicenses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLicense: "",
      licenses: null,
      loadingLicenses: false,
      errorLicenses: "",
      loadingStudents: false,
      loadingEducators: false,
      errorStudents: "",
      students: null,
      educators: null,
      teachersInSchool: null,
      togglingLicense: "",
      togglingLicenseError: "",
      addingOrRemovingAll: false,
      licenseLimitExceedError: false
    };
  }

  componentDidMount() {
    const { schools, match } = this.props;
    const schoolId = match.params.id;
    const school = schools[schoolId];
    const districtId = school.district;
    getSchoolAndDistrictAccountLicenses(
      schoolId,
      this.setState.bind(this),
      "student",
      districtId
    );
    getAllStudents(schoolId, this.setState.bind(this))
      .then(students => {
        return getAllEducators(schoolId, this.setState.bind(this));
      })
      .then(educators => {
        forOwn(schools, (school, key) => {
          if (key === schoolId) {
            if (school.teachers) {
              let teachersInSchool = [];
              forOwn(educators, teacher => {
                if (school.teachers[teacher.id]) {
                  teachersInSchool.push(teacher);
                }
              });
              this.setState({ teachersInSchool });
            }
          }
        });
      });
  }

  componentDidUpdate(prevProps) {
    const { schools, match } = this.props;
    const schoolId = match.params.id;
    const school = schools[schoolId];
    const districtId = school.district;
    const prevSchoolId = prevProps.match.params.id;
    if (prevSchoolId !== schoolId) {
      this.setState({ activeLicense: "" });
      getSchoolAndDistrictAccountLicenses(
        schoolId,
        this.setState.bind(this),
        "student",
        districtId
      );
      getAllStudents(schoolId, this.setState.bind(this))
        .then(students => {
          return getAllEducators(schoolId, this.setState.bind(this));
        })
        .then(educators => {
          forOwn(schools, (school, key) => {
            if (key === schoolId) {
              if (school.teachers) {
                let teachersInSchool = [];
                forOwn(educators, teacher => {
                  if (school.teachers[teacher.id]) {
                    teachersInSchool.push(teacher);
                  }
                });
                this.setState({ teachersInSchool });
              }
            }
          });
        });
    }
  }

  handleClick = id =>
    this.setState({ activeLicense: this.state.activeLicense === id ? "" : id });

  toggleUserLicense = (userId, licenseId) => {
    const { schools, match } = this.props;
    const schoolId = match.params.id;
    const school = schools[schoolId];
    const districtId = school.district;
    const { students } = this.state;
    if (
      checkLicenseLimitForSingleItem(
        licenseId,
        this.state.licenses,
        userId,
        students
      )
    ) {
      this.showLicenseLimitError();
    } else {
      this.setState({ togglingLicense: userId });
      toggleStudentLicense(userId, students, licenseId)
        .then(() => {
          this.setState({ togglingLicense: "" });
          getSchoolAndDistrictAccountLicenses(
            schoolId,
            this.setState.bind(this),
            "student",
            districtId,
            true
          );
        })
        .catch(error => this.setState({ togglingLicenseError: error }));
    }
  };
  removeOrAddAll = (actionType, licenseId, filteredUserList) => {
    const { schools, match } = this.props;
    const schoolId = match.params.id;
    const school = schools[schoolId];
    const districtId = school.district;
    var tlius = tallyLicenseInUserLicenses(licenseId, filteredUserList);
    var difference = tlius.totalLength - tlius.count;
    switch (actionType) {
      case "add_all":
        this.addAll(
          licenseId,
          filteredUserList,
          schoolId,
          districtId,
          difference
        );
        break;
      case "remove_all":
        this.removeAll(
          licenseId,
          filteredUserList,
          schoolId,
          districtId,
          difference,
          tlius
        );
        break;
      default:
        break;
    }
  };
  addAll(licenseId, students, schoolId, districtId, difference) {
    
    if (difference === 0 && true) {
      //All Already Added
      return;
    } else if (checkLicenseLimit(licenseId, this.state.licenses, students)) {
      this.showLicenseLimitError();
    }
    else {
      this.setState({ addingOrRemovingAll: true });
    addOrRemoveStudentLicense(licenseId, students, true)
      .then(() => {
        this.setState({ togglingLicense: "" });
        getSchoolAndDistrictAccountLicenses(
          schoolId,
          this.setState.bind(this),
          "student",
          districtId,
          true
        );
      })
      .catch(error => this.setState({ togglingLicenseError: error }));
    }
  }
  showLicenseLimitError() {
    this.setState({ licenseLimitExceedError: true });
    setTimeout(() => {
      this.setState({ licenseLimitExceedError: false });
    }, 1500);
  }
  removeAll(licenseId, students, schoolId, districtId, difference, tlius) {
    this.setState({ addingOrRemovingAll: true });
    addOrRemoveStudentLicense(licenseId, students, false)
      .then(() => {
        this.setState({ togglingLicense: "" });
        getSchoolAndDistrictAccountLicenses(
          schoolId,
          this.setState.bind(this),
          "student",
          districtId,
          true
        );
      })
      .catch(error => this.setState({ togglingLicenseError: error }));
    if (difference === tlius.totalLength && !false) {
      return;
    }
  }

  render() {
    const {
      activeLicense,
      licenses,
      loadingLicenses,
      errorLicenses,
      loadingStudents,
      loadingEducators,
      errorStudents,
      students,
      addingOrRemovingAll,
      togglingLicense,
      togglingLicenseError,
      teachersInSchool,
      licenseLimitExceedError
    } = this.state;
    const { districts, schools, history, user, match } = this.props;
    const { handleClick, toggleUserLicense, removeOrAddAll } = this;
    const schoolId = match.params.id;
    const loading = !!(loadingLicenses || loadingStudents || loadingEducators);

    return (
      <React.Fragment>
        {!loading ? (
          <React.Fragment>
            <Row className="licenses-header">
              <Col>
                <Selector
                  districts={districts}
                  schools={schools}
                  teachers={null}
                  id={schoolId}
                  user={user}
                  history={history}
                  baseLink="/users/licenses/students/"
                  selectorLevel={"school"}
                />
              </Col>
            </Row>
            {!loadingLicenses && !loadingStudents && !loadingEducators && (
              <Row className="licenses-body">
                <Col xs="12">
                  <Header>Student Licenses</Header>
                </Col>
                <Col xs="12">
                  <h5 className="body-sub-heading">Manage License</h5>
                  {licenses && !loadingLicenses ? (
                    <SelectLicense
                      parentId="student_license"
                      licenses={licenses}
                      schoolId={schoolId}
                      handleClick={handleClick}
                      activeLicense={activeLicense}
                      users={students}
                      toggleUserLicense={toggleUserLicense}
                      loadingUsers={loadingStudents}
                      errorUsers={errorStudents}
                      userType="students"
                      removeOrAddAll={removeOrAddAll}
                      addingOrRemovingAll={addingOrRemovingAll}
                      teachersInSchool={teachersInSchool}
                      resetFilter={this.resetFilter}
                      licenseLimitExceedError={licenseLimitExceedError}
                    />
                  ) : (
                    !loadingLicenses && (
                      <p>No licenses available on this account.</p>
                    )
                  )}
                </Col>
              </Row>
            )}
          </React.Fragment>
        ) : (
          <BeatLoader loading={loading} />
        )}
        <Nav back={"/users/licenses/students"} />
      </React.Fragment>
    );
  }
}

export default StudentLicenses;



// WEBPACK FOOTER //
// ./src/components/Users/Licenses/StudentLicenses.js